export class Announcement {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    updated_by_id!: number;
    publish_at!: Date;
    title!: string;
    body!: string;
    order_link!: boolean;
    custom_link_href!: string;
    custom_link_text!: string;
    dismiss_after!: number
}
